export const NombreColumn = {
    key: 'Nombre',
    name: 'Nombre',
    fieldName: 'Nombre',
    minWidth: 200,
    maxWidth: 350,
    isResizable: true
};
export const VisibleColumn = {
    key: 'Visible',
    name: 'Visible',
    fieldName: 'Visible',
    minWidth: 80,
    maxWidth: 120,
    isResizable: true,
    onRender: (item) => item.Visible ? 'Si' : 'No'
};
export const HeaderTextColumn = {
    key: 'HeaderText',
    name: 'HeaderText',
    fieldName: 'HeaderText',
    minWidth: 150,
    maxWidth: 350,
    isResizable: true
};
export const EmptyColumn = {
    key: '-empty-',
    name: '',
    fieldName: '',
    minWidth: 20,
    maxWidth: 20,
    isResizable: false
};
export const CreadoPortColumn = {
    key: 'CreadoPor',
    name: 'Creado por',
    fieldName: 'CreadoPor',
    minWidth: 150,
    maxWidth: 250,
    isResizable: true
};
export const CreatedByColumn = {
    key: 'CreatedBy',
    name: 'Creado por',
    fieldName: 'CreatedBy',
    minWidth: 150,
    maxWidth: 250,
    isResizable: true
};
export const KeyColumn = {
    key: 'Key',
    name: 'Key',
    fieldName: 'Key',
    minWidth: 150,
    maxWidth: 250,
    isResizable: true
};
export const ValueColumn = {
    key: 'Value',
    name: 'Value',
    fieldName: 'Value',
    minWidth: 150,
    maxWidth: 250,
    isResizable: true
};
export const CreationDateFormattedColumn = {
    key: 'FechaCreacion',
    name: 'Fecha creación',
    fieldName: 'FechaCreacionString2',
    minWidth: 150,
    maxWidth: 250,
    isResizable: true
};
export const FechaCreacionColumn = {
    key: 'FechaCreacion',
    name: 'Fecha creación',
    fieldName: 'FechaCreacion',
    minWidth: 150,
    maxWidth: 250,
    isResizable: true
};
export const CreationDateColumn = {
    key: 'CreationDate',
    name: 'Fecha creación',
    fieldName: 'CreationDate',
    minWidth: 150,
    maxWidth: 250,
    isResizable: true
};
export const ModificadoPorColumn = {
    key: 'ModificadoPor',
    name: 'Modificado por',
    fieldName: 'ModificadoPor',
    minWidth: 150,
    maxWidth: 250,
    isResizable: true
};
export const ModifiedByColumn = {
    key: 'ModifiedBy',
    name: 'Modificado por',
    fieldName: 'ModifiedBy',
    minWidth: 150,
    maxWidth: 250,
    isResizable: true
};
export const FechaModificacionColumn = {
    key: 'FechaModificacion',
    name: 'Fecha modificación',
    fieldName: 'FechaModificacionString2',
    minWidth: 150,
    maxWidth: 250,
    isResizable: true
};
export const ModificationDateColumn = {
    key: 'ModificationDate',
    name: 'Fecha modificación',
    fieldName: 'ModificationDate',
    minWidth: 150,
    maxWidth: 250,
    isResizable: true
};
export const EnableColumn = {
    key: 'Activo',
    name: 'Activo',
    fieldName: 'activo',
    minWidth: 40,
    maxWidth: 50,
    isResizable: true,
    onRender: (item) => item.Activo ? 'Sí' : 'No'
};
export const NameColumn_esES = {
    key: 'Nombre',
    name: 'Nombre',
    fieldName: 'Nombre',
    minWidth: 200,
    maxWidth: 350,
    isResizable: true
};
export const NameColumn_enUS = {
    key: 'Name',
    name: 'Nombre',
    fieldName: 'Name',
    minWidth: 200,
    maxWidth: 350,
    isResizable: true
};
export const NameColumn = {
    key: 'Name',
    name: 'Nombre',
    fieldName: 'Name',
    minWidth: 200,
    maxWidth: 350,
    isResizable: true
};
export const DescriptionColumn = {
    key: 'Description',
    name: 'Descripción',
    fieldName: 'Description',
    minWidth: 200,
    maxWidth: 350,
    isResizable: true
};
export const ProcessName = {
    key: 'ProcessName',
    name: 'Nombre',
    fieldName: 'ProcessName',
    minWidth: 200,
    maxWidth: 300,
    isResizable: false
};
export const YesNoColumn = (key, name, fieldName) => {
    return {
        key,
        name,
        fieldName,
        minWidth: 60,
        maxWidth: 150,
        isResizable: true,
        onRender: item => item[fieldName] === true ? 'Si' : 'No'
    };
};
export const TextColumn = {
    key: 'Text',
    name: 'Text',
    fieldName: 'Text',
    minWidth: 200,
    maxWidth: 350,
    isResizable: true
};
export const IconColumn = {
    key: 'Icon',
    name: 'Icon',
    fieldName: 'Icon',
    minWidth: 200,
    maxWidth: 350,
    isResizable: true
};
